import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
	Container,
	Row,
	Col,
	Card,
	CardBody,
	FormGroup,
	Input,
	Label,
} from "reactstrap";
import {
	AvForm,
	AvField,
	AvRadioGroup,
	AvRadio,
	AvCheckboxGroup,
	AvCheckbox,
	AvInput,
} from "availity-reactstrap-validation";
import Select from "react-select";
import { Stepper } from "react-form-stepper";
import FileUpload from "components/Common/file-upload/file-upload.component";
import MyMap from "components/Common/google-map/MyMap";
import { Gogovernorates, furnishing } from "Enums/fixedData";
import SelectOptions from "components/SelectOptions";
import FinishingTypesService from "services/Admin/FinishingTypesService";
import UnitTypesService from "services/Admin/UnitTypesService";
import { toast } from "react-toastify";
import CitiesService from "services/Admin/CitiesService";
import ResaleService from "services/Admin/ResaleService";
import FacingService from "services/Admin/FacingService";
import PaymentPlan from "../PaymentPlan";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import CancelModal from "../../Compound/CancelModal";
import SuccessModal from "components/SucessModal";
import CompoundService from "services/Admin/CompoundService";
import SellerService from "services/Admin/SellerService";
import Language from "Enums/Language";
import { useLocation } from "react-router-dom";
import "./styles.scss";
import AreaService from "services/Admin/AreasService";
import { adminPrefix } from "configs/routePrefix";
import AmenitiesService from "services/Admin/AmenitiesService";

const initialState = {
	in_compound: false,
	en: "",
	ar: "",
	ru: "",
	zh: "",
	compound: "",
	selectedFinishingType: null,
	selectUnitType: null,
	bedRoom_num: "",
	floor: "",
	bathroom_num: "",
	selectedCity: null,
	selectedArea: "",
	governorate: null,
	facing: null,
	lat: 30.005493,
	lng: 31.477898,
	street: "",
	total_built_up_area: "",
	client_id: null,
	furnishing: "",
	descrip_ar: "",
	descrip_en: "",
	descrip_ru: "",
	descrip_zh: "",
	address_ar: "",
	address_en: "",
	address_ru: "",
	address_zh: "",
	amenities: [],
	// amenitiesOther: "",
	standalone: "0",
	builtArea: "",
	landArea: "",
	bank_account: "",
	swift: "",
	iban: "",
};

const CreateResale = (props) => {
	const [uploadState, setUploadState] = useState(false);
	const [formStep, setFormStep] = useState(0);
	const [modal, setModal] = useState(false);
	const [successModal, setSuccessModal] = useState(false);
	const [formData, setFormData] = useState(initialState);
	const [mediaIds, setMediaIds] = useState([]);
	const [videosIds, setVideosIds] = useState([]);
	const [contractImages, setContractImages] = useState([]);
	const [nationalId, setNationalId] = useState([]);
	const [termsAndConditionsIds, setTermsAndConditionsIds] = useState([]);
	const [cityOptions, setCityOptions] = useState([]);
	const [areOptions, setAreaOptions] = useState([]);
	const [facingOptions, setFacingOptions] = useState([]);
	const [FinishingOptions, setFinishingOptions] = useState([]);
	const [unitTypeOptions, setUnitTypeOptions] = useState([]);
	const [clientOptions, setClientOptions] = useState([]);
	const [compoundOpttions, setCompoundOptions] = useState([]);
	const [amenitiesOptions, setAmenitiesOptions] = useState([]);
	const [loadAmenities, setLoadAmenities] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loadingMedia, setLoadingMedia] = useState(false);
	const [showMap, setShowMap] = useState(false);
	// const [mapRender, setMapRender] = useState(0);
	const [compound, setCompound] = useState();
	const compoundService = new CompoundService();
	const resaleService = new ResaleService();
	const facingService = new FacingService();
	const amenitiesService = new AmenitiesService();
	const location = useLocation();
	const id = props.match.params.id;

	const usePathname = () => {
		return location.pathname.split("/")[3];
	};

	const setAreaDropDownOptions = (cityId) => {
		new AreaService().getDropDown(cityId).then((res) => {
			const newOptions = res.data?.map((item) => {
				return {
					...item.name,
					label: item.name.en,
					value: item.id,
				};
			});
			setAreaOptions([...newOptions]);
		});
	};

	useEffect(() => {
		setAreaDropDownOptions(formData.selectedCity?.value);
	}, [formData.selectedCity]);

	useEffect(() => {
		new CitiesService().getDropDown().then((res) => {
			const newOptions = res.data?.map((item) => {
				return {
					...item.name,
					label: item.name.en,
					value: item.id,
				};
			});
			setCityOptions([...newOptions]);
		});

		facingService.getDropDown().then((res) => {
			const newOptions = res.data?.map((item) => {
				return {
					...item.name,
					label: item.name.en,
					value: item.id,
				};
			});
			setFacingOptions([...newOptions]);
		});
		amenitiesService.getList({ status: 1 }).then((res) => {
			const newOptions = res.data?.data?.map((item) => {
				return {
					...item.name,
					label: item.name.en,
					value: item.id,
				};
			});
			setAmenitiesOptions([...newOptions]);
			setLoadAmenities(true);
		});
	}, []);

	// useEffect(() => {
	//     if (id && usePathname() !== "edit") {
	//         const selectedClient = clientOptions.find(item => parseInt(item.value) === parseInt(id))
	//         setFormData({
	//             ...formData,
	//             client_id: { ...selectedClient }
	//         })
	//     }
	// }, [clientOptions])

	const getEditResaleData = async () => {
		const response = await compoundService.getDropDown();
		const newOptions = response.data.map((item) => {
			return {
				label: item.name.en,
				value: item.id,
			};
		});
		setCompoundOptions(newOptions);
		if (id && usePathname() === "edit-resale") {
			setLoading(true);
			resaleService?.find(id).then((res) => {
				if (res && res.status === SuccessOk) {
					// let newAmenities= !!res.data?.amenities_ids?.length ? res.data?.amenities_ids?.filter(({label: id1}) => amenitiesOptions.some(({label: id2})=> id1 === id2 )) : []
					// let newAmenitiesOther = !!res.data?.amenities ? res.data?.amenities?.filter(({label: id1}) => !amenitiesOptions.some(({label: id2})=> id1 === id2 )) : []
					setCompound(res.data?.compound.name);
					setFormData({
						...formData,
						payment_plan: res.data.payment_plan,
						in_compound: res.data.in_compound,
						showMap: !!res.data.location.lat ? 1 : 0,
						compound: {
							label: res.data.compound.name,
							value: res.data.compound.id,
						},
						ar: res.data.name.ar,
						en: res.data.name.en,
						ru: res.data.name.ru,
						zh: res.data.name.zh,
						amenities: !!res.data?.amenities?.length
							? res.data?.amenities?.map((ame) => {
									return {
										label: ame?.name?.en,
										value: ame?.id,
										id: ame?.id,
									};
							  })
							: [],
						// amenitiesOther: {...newAmenitiesOther[0]},
						bank_account: res.data?.bank_account,
						swift: res.data?.swift,
						iban: res.data?.iban,
						selectedFinishingType: {
							label: res.data.finishing_type.name,
							value: res.data.finishing_type.id,
						},
						selectUnitType: {
							label: res.data.unit_type.name.en,
							value: res.data.unit_type.id,
						},
						bedRoom_num: res.data.bedrooms,
						floor: res.data.floor,
						bathroom_num: res.data.bathrooms,
						selectedCity: {
							...res.data.location.City,
							label: res.data.location.City.en,
						},
						governorate: {
							...res.data.location.governorate,
							label: res.data.location.governorate.en,
						},
						facing: {
							value: res.data.facing,
							label: res.data.facing,
						},
						lat: !!Number(res.data.location.lat)
							? Number(res.data.location?.lat)
							: 30.005493,
						lng: !!Number(res.data.location.lang)
							? Number(res.data.location?.lang)
							: 31.477898,
						showMap:
							!!res.data.location.lat && !!res.data.location.lang
								? true
								: false,
						total_built_up_area: res.data.total_built_up_area,
						total_land_area: !!res.data.total_land_area
							? res.data.total_land_area
							: null,
						standalone: !!res.data.total_land_area ? "1" : "0",
						// area_en: res.data.location.area.en,
						// area_ar: res.data.location.area.ar,
						// area_ru: res.data.location.area.ru,
						// area_zh: res.data.location.area.zh,
						descrip_ar: res.data.description.ar,
						descrip_en: res.data.description.en,
						descrip_ru: res.data.description.ru,
						descrip_zh: res.data.description.zh,
						address_ar: res.data.location.street_address.ar,
						address_en: res.data.location.street_address.en,
						address_ru: res.data.location.street_address.ru,
						address_zh: res.data.location.street_address.zh,
						client_id: {
							label: `${res.data.client.id} / ${res.data.client.name}`,
							value: res.data.client.id,
						},
						furnishing: {
							label: res.data.furnishing,
							value: res.data.furnishing,
						},
						status: res.data.status,
						total_land_area:
							!!res.data?.total_land_area && res.data?.total_land_area,
						selectedArea: {
							label: res.data.area.name,
							value: res.data.area.id,
						},
					});
					setContractImages([...res.data.contracts]);
					setMediaIds([...res.data.images]);
					setVideosIds([...res.data?.videos]);
					setNationalId([...res.data.national_ids_images]);
					setTermsAndConditionsIds([...res.data?.terms_and_conditions]);
					// setMapRender(mapRender + 1);
					setShowMap(
						!!Number(res.data.location.lat) && !!Number(res.data.location.lang)
							? true
							: false
					);
				}
				setLoading(false);
			});
		}
	};

	useEffect(() => {
		getEditResaleData();
	}, [loadAmenities]);

	useEffect(() => {
		// template string inside query Selectpor
		const value = 2 * formStep + 1;
		const element = document.querySelector(`.RFS-Label-d${value}`);
		if (element) {
			element.style.fontWeight = "700";
		}
	}, [formStep]);

	const addNewRelease = (payment) => {
		setLoading(true);
		const data = {
			...payment,
			name: {
				en: formData.en,
				ar: formData.ar,
				ru: formData.ru,
				zh: formData.zh,
			},
			in_compound: formData.in_compound,
			compound_id: formData.compound.value,
			area_id: formData.selectedArea.value,
			description: {
				en: formData.descrip_en,
				ar: formData.descrip_ar,
				ru: formData.descrip_ru,
				zh: formData.descrip_zh,
			},
			facing: formData.facing.label,
			floor: parseInt(formData.floor),
			bank_account: formData.bank_account,
			swift: formData?.swift,
			iban: formData?.iban,
			bedrooms: parseInt(formData.bedRoom_num),
			bathrooms: parseInt(formData.bathroom_num),
			client_id: formData.client_id.value,
			total_built_up_area: parseInt(formData.total_built_up_area),
			total_land_area:
				formData.standalone === "1"
					? parseInt(formData?.total_land_area)
					: null,
			finishing_type_id: formData.selectedFinishingType.value,
			images_ids: [...mediaIds].map((item) => item.id),
			national_ids: [...nationalId].map((item) => item.id),
			videos_ids: [...videosIds].map((item) => item.id),
			terms_and_conditions_ids: [...termsAndConditionsIds].map(
				(item) => item.id
			),
			furnishing: formData.furnishing.value,
			unit_type_id: formData.selectUnitType.value,
			contracts_ids: [...contractImages].map((item) => item.id),
			amenities_ids: formData.amenities?.map((item) => item?.value),

			location: {
				lat: showMap ? formData.lat : 0,
				lang: showMap ? formData.lng : 0,
				governorate: formData.governorate,
				City: formData.selectedCity,
				street_address: {
					ar: formData.address_ar,
					en: formData.address_en,
					ru: formData.address_ru,
					zh: formData.address_zh,
				},
			},
		};
		// if (formData.in_compound) data["compound_name"] = formData.selectedCompound.label
		if (id) data["status"] = formData.status;
		if (id) {
			resaleService.update(id, data).then((res) => {
				setLoading(false);
				if (res && res.status === SuccessOk) {
					setSuccessModal(true);
				}
			});
		} else {
			resaleService.create(data).then((res) => {
				setLoading(false);
				if (res && res.status === SuccessCreated) {
					setSuccessModal(true);
				}
			});
		}
	};

	const updateLocationPositions = (lat, lng) => {
		setFormData({ ...formData, ...{ lat, lng } });
	};
	const updatedAttachment = (attachments, type) => {
		if (type === "media_id") {
			let media = [...mediaIds, ...attachments]?.filter(
				(item) =>
					item?.path?.endsWith(".png") ||
					item?.path?.endsWith(".jpeg") ||
					item?.path?.endsWith(".jpg")
			);
			setMediaIds(media);
		} else if (type === "video_id") {
			let media = [...videosIds, ...attachments]?.filter(
				(item) =>
					item?.path?.endsWith(".mp4") ||
					item?.path?.endsWith(".mkv") ||
					item?.path?.endsWith(".ogg")
			);
			setVideosIds(media);
		} else if (type === "contract_media_id") {
			setContractImages([...contractImages, ...attachments]);
		} else if (type === "terms_and_conditions_ids") {
			setTermsAndConditionsIds([...termsAndConditionsIds, ...attachments]);
		} else {
			setNationalId([...nationalId, ...attachments]);
		}
	};
	const deleteAttachment = (Items, type) => {
		if (type === "media_id") {
			let updatedMedia = mediaIds.filter((item) => item.id !== Items[0].id);
			setMediaIds(updatedMedia);
		} else if (type === "video_id") {
			let updatedMedia = videosIds.filter((item) => item.id !== Items[0].id);
			setVideosIds(updatedMedia);
		} else if (type === "contract_media_id") {
			let updatedMedia = contractImages.filter(
				(item) => item.id !== Items[0].id
			);
			setContractImages(updatedMedia);
		} else if (type === "terms_and_conditions_ids") {
			let updatedMedia = termsAndConditionsIds.filter(
				(item) => item.id !== Items[0].id
			);
			setTermsAndConditionsIds(updatedMedia);
		} else {
			let updatedMedia = nationalId.filter((item) => item.id !== Items[0].id);
			setNationalId(updatedMedia);
		}
	};
	const nextFormStep = (step) => {
		if (step) {
			setFormStep(step);
		} else {
			setFormStep(formStep + 1);
		}
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};
	const lastFormStep = () => {
		setFormStep(formStep - 1);
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};
	const handleFieldChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};
	const renderButton = () => {
		if (formStep === 4) {
			return (
				<>
					<Col md={8}>
						<Col md={3}>
							<button
								className="btn btn-light w-100 border-2 border-success text-success"
								onClick={() => setModal(true)}>
								Cancel
							</button>
						</Col>
						<Col md={6}></Col>
					</Col>
					<Col md={2} className="d-flex flex-row-reverse ">
						<button
							className="btn btn-light w-100 border-2 border-success text-success"
							onClick={lastFormStep}>
							Back
						</button>
					</Col>
					<Col md={2} className="d-flex flex-row-reverse ">
						<button
							type="submit"
							className="btn btn-success w-100 "
							disabled={uploadState ? true : loading ? true : false}>
							Submit
						</button>
					</Col>
				</>
			);
		} else if (formStep === 0) {
			return (
				<>
					<Col md={8}>
						<Col md={3}>
							<button
								className="btn btn-light w-100 border-2 border-success text-success"
								onClick={() => setModal(true)}>
								Cancel
							</button>
						</Col>
						<Col md={6}></Col>
					</Col>
					<Col md={2} className="d-flex flex-row-reverse"></Col>
					<Col md={2} className="d-flex flex-row-reverse">
						<button
							type="submit"
							className="btn btn-success   w-100 "
							disabled={uploadState ? true : loading ? true : false}>
							Next
						</button>
					</Col>
				</>
			);
		} else {
			return (
				<>
					<Col md={8}>
						<Col md={3}>
							<button
								className="btn btn-light w-100 border-2 border-success text-success"
								onClick={() => setModal(true)}>
								Cancel
							</button>
						</Col>
						<Col md={6}></Col>
					</Col>
					<Col md={2} className="d-flex flex-row-reverse">
						<button
							disabled={loadingMedia}
							className="btn btn-light w-100 border-2 border-success text-success"
							onClick={lastFormStep}>
							Back
						</button>
					</Col>
					<Col md={2} className="d-flex flex-row-reverse">
						<button
							type="submit"
							className="btn btn-success   w-100 "
							disabled={uploadState || loadingMedia}>
							Next
						</button>
					</Col>
				</>
			);
		}
	};
	const ButtonCard = () => {
		return (
			<Row>
				<Card>
					<CardBody>
						<Row className="d-flexjustify-content-between">
							{renderButton()}
						</Row>
					</CardBody>
				</Card>
			</Row>
		);
	};
	const firstFormSubmition = () => {
		if (!formData.selectedFinishingType) {
			toast.error("Finishing Type field is required");
			return;
		} else if (formData.in_compound && !formData.compound) {
			toast.error("Compound field is required");
			return;
		} else if (!formData.furnishing) {
			toast.error("furnishing field is required");
			return;
		} else if (!formData.facing) {
			toast.error("Facing field is required");
			return;
		} else if (!formData.selectUnitType) {
			toast.error("Unit Type field is required");
			return;
		} else if (!formData.client_id) {
			toast.error("client  field is required");
			return;
		} else if (!/^[a-zA-Z ]*$/.test(formData.name)) {
			toast.error("resale name format is invalid");
		} else if (validateDescription()) {
			return;
		} else {
			// if(!!formData?.amenitiesOther.label){
			//     // let newAmenities= formData.amenities?.filter(item => item.label !== "Other")
			//     setFormData({
			//         ...formData,
			//         amenities: [...newAmenities, !!formData?.amenitiesOther.label && formData?.amenitiesOther],
			//     })
			// }
			// if(!formData?.amenities?.length){
			//     setFormData({...formData, amenities: []})
			// }
			nextFormStep();
		}
	};

	const validateDescription = () => {
		if (!!formData.descrip_en && !validate(formData.descrip_en)) {
			toast.error("Description (en) format invalid");
			return true;
		}
		// else if (!!formData.descrip_ar && !validateArabic(formData.descrip_ar)) {
		//     toast.error("Description (ar) format invalid")
		//     return true
		// }
		// else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.descrip_ru)) {
		//     toast.error("Description (ru) format invalid")
		//     return true
		// } else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.descrip_zh)) {
		//     toast.error("Description (zh) format invalid")
		//     return true
		// } else {
		//     return false
		// }
	};
	const thirdFormSubmition = () => {
		if (!formData.selectedCity) {
			toast.error("City is required");
			return;
		} else if (!formData.governorate) {
			toast.error("Governorate is required");
			return;
		} else if (validateAddress()) {
			return;
		} else if (validateArea()) {
			return;
		} else {
			if (!showMap) {
				setFormData({ ...formData, lat: null, lang: null, showMap });
			}
			nextFormStep();
		}
	};
	const forthFormSubmition = () => {
		// if (contractImages.length === 0) {
		//     return toast.error("Contract images are required")
		// }
		// if (nationalId.length === 0){
		//     return toast.error("National Id images are required")
		// }
		if (termsAndConditionsIds.length === 0) {
			return toast.error("Terms and Conditions pdf are required");
		}
		// if(formData.bank_account !== '' && /^[^0-9]+$/.test(formData.bank_account)){
		//     return toast.error("Account Number format invalid")
		// }
		// if(formData.iban !== '' && /[^a-zA-Z-0-9]/.test(formData.iban)){
		//     return toast.error("IBAN format invalid")
		// }
		// if(formData.swift !== '' && /[^a-zA-Z-0-9]+$/.test(formData.swift)){
		//     return toast.error("Swift Code format invalid")
		// }

		nextFormStep();
	};

	const validateAddress = () => {
		if (!validate(formData.address_en)) {
			toast.error("Address (en) format invalid");
			return true;
		} else if (!!formData.address_ar && !validateArabic(formData.address_ar)) {
			toast.error("Address (ar) format invalid");
			return true;
		}

		// else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.address_ru)) {
		//     toast.error("Address (ru) format invalid")
		//     return true
		// } else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.address_zh)) {
		//     toast.error("Address (zh) format invalid")
		//     return true
		// } else {
		//     return false
		// }
	};
	const validateArea = () => {
		if (!formData.selectedArea) {
			toast.error("Area are required");
			return true;
		}
		// else if (!!formData.area_ar && !validateArabic(formData.area_ar)) {
		//     toast.error("Area (ar) format invalid")
		//     return true
		// }

		// else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.area_ru)) {
		//     toast.error("Area (ru) format invalid")
		//     return true
		// } else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.area_zh)) {
		//     toast.error("Area (zh) format invalid")
		//     return true
		// } else {
		//     return false
		// }
	};
	useEffect(() => {
		// template string inside query Selectpor
		const value = 2 * formStep + 1;
		const element = document.querySelector(`.RFS-Label-d${value}`);
		if (element) {
			element.style.fontWeight = "700";
		}
	}, [formStep]);

	return (
		<>
			<div className="page-content">
				<MetaTags>
					<title>{id ? "Update Resale" : "create Resale"}</title>
				</MetaTags>
				<Container>
					<Row className="mx-4">
						<h4>{id ? "Update Resale" : "Add New Resale"}</h4>
					</Row>
					<Row className="position-relative .resale-stepper">
						<div
							style={{
								width: "4.5%",
								height: "0.4em",
								position: "absolute",
								top: "29%",
								left: "6%",
								background: "#556ee6",
							}}></div>
						<Stepper
							steps={[
								{ label: "Resale Information" },
								{ label: "Photos" },
								{ label: "Location" },
								{ label: "Upload Contract & National Id" },
								{ label: "Payment Plan" },
							]}
							activeStep={formStep}
							connectorStateColors={true}
							styleConfig={{
								activeBgColor: "white",
								activeTextColor: "#495057",
								inactiveBgColor: "#FFFFFF",
								inactiveTextColor: "#495057",
								completedBgColor: "#FFFFFF",
								completedTextColor: "#495057",
								size: "3em",
							}}
							connectorStyleConfig={{
								size: ".4em",
								completedColor: "#556ee6",
								activeColor: "#556ee6",
								disabledColor: "#f8f8fb",
								disabledColor: "#f6f6f6",
							}}
							className={"stepper"}
							stepClassName={"stepper__step"}
						/>
						{formStep === 4 && (
							<div
								style={{
									width: "3.5%",
									height: "0.4em",
									position: "absolute",
									top: "26%",
									right: "6.7%",
									background: "#556ee6",
								}}></div>
						)}
					</Row>
				</Container>

				{formStep === 0 && (
					<AvForm onValidSubmit={(e, v) => firstFormSubmition()}>
						<Container>
							<Card>
								<CardBody>
									<Row>
										<h4>Resale Information</h4>
										<p>Fill all the information below</p>
									</Row>
									<Row className="mb-4 bg-light p-2">
										<Col md={6} className="my-3">
											<h6>Listing in Compound</h6>
										</Col>
										<Col md={6} className="d-flex flex-row-reverse">
											<div className="form-check form-switch form-switch-md mb-1">
												<AvField
													name="in_compound"
													checked={formData.in_compound}
													value={formData.in_compound}
													type="checkbox"
													className="form-check-input"
													id="has_status"
													onChange={(e) => {
														setFormData({
															...formData,
															[e.target.name]: e.target.checked,
														});
													}}
												/>
											</div>
										</Col>
										{formData.in_compound && (
											<Col md={6}>
												<label>Compound Name</label>
												<Select
													label="Compound "
													placeholder="Select"
													options={compoundOpttions}
													className="mb-3 "
													required={formData.in_compound}
													onChange={(data) => {
														setFormData({ ...formData, compound: data });
													}}
													value={formData.compound}
												/>
											</Col>
										)}
									</Row>
									<Row>
										<Row>
											{Language.LIST.map((lan, index) => {
												return (
													<Col md={6} key={index}>
														<AvField
															className="mb-3"
															name={lan.name}
															label={`Resale Name (${lan.name})`}
															bsSize="lg"
															value={formData[`${lan.name}`]}
															onChange={(e) => handleFieldChange(e)}
															required={lan.name === "en" ? true : false}
															errorMessage="This field is required"
															placeholder={
																lan.name === "en"
																	? "English"
																	: lan.name === "ar"
																	? "العربية"
																	: lan.name === "zh"
																	? "中文"
																	: "Русский"
															}
														/>
													</Col>
												);
											})}

											<Col md={6}>
												<SelectOptions
													label={"Client Name"}
													placeholder={"Select"}
													options={clientOptions}
													handleSelectChange={(data) => {
														setFormData({ ...formData, client_id: data });
													}}
													selectedOption={formData.client_id}
													Service={SellerService}
													setOptions={(options) => {
														const customOptions = options.map((opt) => ({
															label: `${opt.value} / ${opt.label}`,
															value: opt.value,
														}));
														setClientOptions(customOptions);
													}}
												/>
											</Col>
											<Col md={6}>
												<SelectOptions
													label="Unit Type"
													placeholder="Select"
													options={unitTypeOptions}
													handleSelectChange={(data) => {
														setFormData({ ...formData, selectUnitType: data });
													}}
													selectedOption={formData.selectUnitType}
													Service={UnitTypesService}
													setOptions={(options) => {
														let customOptions = options?.filter(
															(res) => typeof res.label === "string"
														);
														setUnitTypeOptions(customOptions);
													}}
												/>
											</Col>
										</Row>
									</Row>
									<Row>
										{Language.LIST.map((lan, index) => {
											return (
												<Col md={12} key={index}>
													<AvField
														className="mb-3"
														name={lan.descrip_name}
														label={`Description (${lan.name})`}
														bsSize="lg"
														value={formData[`${lan.descrip_name}`]}
														onChange={(e) => handleFieldChange(e)}
														required={false}
														minLength={
															formData[`${lan.descrip_name}`] !== "" && 2
														}
														type="textarea"
														placeholder={
															lan.name === "en"
																? "English"
																: lan.name === "ar"
																? " العربية"
																: lan.name === "zh"
																? "中文"
																: "Русский"
														}
													/>
												</Col>
											);
										})}
									</Row>
								</CardBody>
							</Card>
							<Card>
								<CardBody>
									<Row>
										<Col md={6}>
											<label>Facing</label>
											<Select
												placeholder="Select"
												options={facingOptions}
												className="mb-3 p-1"
												onChange={(data) => {
													setFormData({ ...formData, facing: data });
												}}
												value={formData.facing}
											/>
										</Col>
										<Col md={6}>
											<label>Furnishing</label>
											<Select
												placeholder="Select"
												options={furnishing}
												className="mb-3 p-1"
												onChange={(data) => {
													setFormData({ ...formData, furnishing: data });
												}}
												value={formData.furnishing}
											/>
										</Col>
										<Col md={6}>
											<SelectOptions
												label="Finishing"
												placeholder="Select"
												options={FinishingOptions}
												handleSelectChange={(data) => {
													setFormData({
														...formData,
														selectedFinishingType: data,
													});
												}}
												selectedOption={formData.selectedFinishingType}
												Service={FinishingTypesService}
												setOptions={(options) => {
													setFinishingOptions(options);
												}}
											/>
										</Col>
									</Row>
								</CardBody>
							</Card>
							<Card>
								<CardBody>
									<Row>
										<Col md={6}>
											<AvField
												className="mb-3"
												name={"bedRoom_num"}
												label={"No. Of Bedrooms"}
												bsSize="lg"
												value={formData.bedRoom_num}
												onChange={(e) => handleFieldChange(e)}
												required
												errorMessage="This field is required"
												placeholder={"bedRoom number"}
												type="number"
												min={"1"}
												max={"30"}
												pattern="/^[0-9]+$/"
											/>
										</Col>
										<Col md={6}>
											<AvField
												className="mb-3"
												name={"bathroom_num"}
												label={"No. Of Bathrooms"}
												bsSize="lg"
												value={formData.bathroom_num}
												onChange={(e) => handleFieldChange(e)}
												required
												errorMessage="This field is required"
												placeholder={"bathroom number"}
												type="number"
												min={"0"}
												max={"30"}
												pattern="/^[0-9]+$/"
											/>
										</Col>
									</Row>
								</CardBody>
							</Card>
							<Card>
								<CardBody>
									<Row>
										<Col md={8} className="my-4">
											<h6>Is the unit standalone?</h6>
										</Col>

										<Col md={4} className="my-4 ">
											<AvRadioGroup
												inline
												name="standalone"
												required
												value={formData.standalone}
												onChange={handleFieldChange}
												errorMessage="This field is required">
												<AvRadio className="mx-3" label="Yes" value="1" />
												<AvRadio className="mx-3" label="No" value="0" />
											</AvRadioGroup>
										</Col>
										<Row>{!formData.standalone}</Row>
										{formData.standalone === "0" && (
											<>
												<Col md={6}>
													<AvField
														errorMessage="this field is required"
														className="mb-3"
														name={"total_built_up_area"}
														label="Total Build Up Area"
														bsSize="lg"
														value={formData.total_built_up_area}
														onChange={(e) => handleFieldChange(e)}
														required
														placeholder="Total Build Up Area"
														type="number"
														min={"1"}
														pattern="/^[0-9]+$/"
													/>
												</Col>
												<Col md={6}>
													<AvField
														errorMessage="this field is required"
														className="mb-3"
														name={"floor"}
														label="Floor Number"
														bsSize="lg"
														value={formData.floor}
														onChange={(e) => handleFieldChange(e)}
														required
														placeholder="Floor Number"
														type="number"
														min={"0"}
														pattern="/^[0-9]+$/"
													/>
												</Col>
											</>
										)}
										{formData.standalone === "1" && (
											<>
												<Col md={6}>
													<AvField
														errorMessage="this field is required"
														className="mb-3"
														name={"total_built_up_area"}
														label="Build Up Area"
														bsSize="lg"
														value={formData.total_built_up_area}
														onChange={(e) => handleFieldChange(e)}
														required
														placeholder="Build Up Area"
														type="number"
														min={"1"}
														pattern="/^[0-9]+$/"
													/>
												</Col>
												<Col md={6}>
													<AvField
														errorMessage="this field is required"
														className="mb-3"
														name={"total_land_area"}
														label="Total Land Area"
														bsSize="lg"
														value={formData.total_land_area}
														onChange={(e) => handleFieldChange(e)}
														required
														placeholder="Total Land Area"
														type="number"
														min={"1"}
														pattern="/^[0-9]+$/"
													/>
												</Col>
												<Col md={6}>
													<AvField
														errorMessage="this field is required"
														className="mb-3"
														name={"floor"}
														label="Number of Floor"
														bsSize="lg"
														value={formData.floor}
														onChange={(e) => handleFieldChange(e)}
														required
														placeholder="Number of Floor"
														type="number"
														min={"0"}
														pattern="/^[0-9]+$/"
													/>
												</Col>
											</>
										)}
									</Row>
								</CardBody>
							</Card>
							<Card>
								<CardBody>
									<Row className="mb-4 p-2">
										<Col md={6}>
											<label>Amenities</label>
											<Select
												label="Compound "
												placeholder="Select"
												options={[...amenitiesOptions]}
												className="mb-3 "
												onChange={(data) => {
													setFormData({ ...formData, amenities: data });
												}}
												value={formData.amenities}
												isMulti={true}
											/>
										</Col>
										{/* {!!formData?.amenities?.length && (formData.amenities.find(item => item.label === "Other") || !!formData?.amenitiesOther?.label) && <Col md={12}  >
                                            <AvField
                                                className="mb-0"
                                                type="textarea"
                                                label="Amenities Name"
                                                name={"amenitiesOther"}
                                                bsSize="lg"
                                                value={formData?.amenitiesOther.label}
                                                minLength={formData?.amenitiesOther?.label === "" ? 1 : 2}
                                                onChange={e => setFormData({...formData, amenitiesOther: {
                                                    value: e.target.value,
                                                    label: e.target.value,
                                                    en: e.target.value,
                                                }})}
                                                required
                                                errorMessage="This field is required"
                                                placeholder={'Amenities Name'}
                                            />
                                        </Col>} */}
									</Row>
								</CardBody>
							</Card>
						</Container>
						<ButtonCard />
					</AvForm>
				)}
				{formStep === 1 && (
					<AvForm
						onValidSubmit={(e, v) => {
							if (mediaIds.length === 0) {
								toast.error("Please Upload Unit Photo");
								return;
							} else {
								nextFormStep();
							}
						}}>
						<Container>
							<Card>
								<CardBody>
									<Row>
										<Col md={12}>
											<FileUpload
												accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG"
												label="Upload Photo"
												attachmentType="media_id"
												setUpload={() => {}}
												loading={true}
												setLoadingMedia={setLoadingMedia}
												attachmentData={mediaIds}
												updatedAttachment={updatedAttachment}
												deleteAttachment={deleteAttachment}
												multiple
												setUploadState={setUploadState}
											/>
										</Col>
									</Row>
									<Row className="my-4">
										<Col md={12}>
											<FileUpload
												accept="video/mp4,video/x-m4v,video/*"
												label={"Upload Videos (Optional)"}
												attachmentType="video_id"
												attachmentData={videosIds}
												setUpload={() => {}}
												loading={true}
												setLoadingMedia={setLoadingMedia}
												updatedAttachment={updatedAttachment}
												deleteAttachment={deleteAttachment}
												setUploadState={setUploadState}
												multiple
											/>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Container>
						<ButtonCard />
					</AvForm>
				)}

				{formStep === 2 && (
					<AvForm onValidSubmit={(e, v) => thirdFormSubmition()}>
						<Container>
							<Card>
								<CardBody>
									{/* {!!mapRender && ( */}

									<Row>
										<h4>Location</h4>
										<p>Fill the information below</p>
									</Row>
									{showMap && (
										<Row className="mb-4">
											<MyMap
												updateLocationPositions={updateLocationPositions}
												lat={formData.lat}
												lng={formData.lng}
												draggable={true}
												onMouseOut={true}
											/>
										</Row>
									)}

									<Row className="mb-3 mx-1">
										<FormGroup check>
											<Input
												id="exampleCheck"
												name="check"
												type="checkbox"
												checked={showMap}
												onChange={(e) => {
													setShowMap(e.target.checked);
												}}
											/>
											<Label check for="exampleCheck">
												Display Map in Resale
											</Label>
										</FormGroup>
									</Row>
									<Row>
										<Col md={6}>
											<label>Governorate</label>
											<Select
												placeholder="Select"
												options={Gogovernorates}
												className="mb-3"
												onChange={(data) => {
													setFormData({ ...formData, governorate: data });
												}}
												value={formData.governorate}
											/>
										</Col>
										<Col md={6}>
											<label>City</label>
											<Select
												placeholder="Select"
												options={cityOptions}
												className="mb-3"
												onChange={(data) => {
													setFormData({
														...formData,
														selectedCity: data,
														selectedArea: "",
													});
													setAreaDropDownOptions(data.value);
												}}
												value={formData.selectedCity}
											/>
										</Col>
										<Col md={6}>
											<label>Location</label>
											<Select
												placeholder="Select"
												options={areOptions}
												className="mb-3"
												onChange={(data) => {
													setFormData({ ...formData, selectedArea: data });
												}}
												value={formData.selectedArea}
											/>
										</Col>
										<Row>
											{Language.LIST.map((lan, index) => {
												return (
													<Col md={6} key={index}>
														<AvField
															errorMessage="This field is required"
															className="mb-3"
															name={lan.address_name}
															label={
																lan.name !== "zh"
																	? `Address (${lan.name})`
																	: "Address (Chinese)"
															}
															bsSize="lg"
															required={lan.name == "en" ? true : false}
															value={formData[`${lan.address_name}`]}
															onChange={(e) => handleFieldChange(e)}
															minLength={
																formData[`${lan.address_name}`] !== "" && 2
															}
															placeholder={
																lan.name === "en"
																	? " English"
																	: lan.name === "ar"
																	? "العربية "
																	: lan.name === "zh"
																	? "中文"
																	: "Русский"
															}
														/>
													</Col>
												);
											})}
										</Row>
									</Row>
								</CardBody>
							</Card>
						</Container>
						<ButtonCard />
					</AvForm>
				)}
				{formStep === 3 && (
					<AvForm onValidSubmit={(e, v) => forthFormSubmition()}>
						<Container>
							<Row>
								<Card>
									<CardBody>
										<Row>
											<Col md={12}>
												<FileUpload
													accept=".jpg,.png,.jpeg"
													label="Contract Images"
													attachmentType="contract_media_id"
													attachmentData={contractImages}
													setUpload={() => {}}
													loading={true}
													setLoadingMedia={setLoadingMedia}
													updatedAttachment={updatedAttachment}
													deleteAttachment={deleteAttachment}
													multiple
													setUploadState={setUploadState}
												/>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Row>
							<Row>
								<Card>
									<CardBody>
										<Row>
											<Col md={12}>
												<FileUpload
													accept=".jpg,.png,.jpeg"
													label="National Id Images"
													attachmentType="national_id"
													loading={true}
													setLoadingMedia={setLoadingMedia}
													attachmentData={nationalId}
													setUpload={() => {}}
													updatedAttachment={updatedAttachment}
													deleteAttachment={deleteAttachment}
													multiple
													setUploadState={setUploadState}
												/>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Row>
							<Row>
								<Card>
									<CardBody>
										<Row>
											<Col md={12}>
												<FileUpload
													accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/*, .pdf,.doc,.docx"
													label="Upload pdf with Signature"
													attachmentType="terms_and_conditions_ids"
													attachmentData={termsAndConditionsIds}
													updatedAttachment={updatedAttachment}
													setUpload={() => {}}
													loading={true}
													setLoadingMedia={setLoadingMedia}
													deleteAttachment={deleteAttachment}
													multiple
													setUploadState={setUploadState}
												/>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Row>
							<Row>
								<Card>
									<CardBody>
										<Row>
											<h5 className="mb-3">Bank Account Information</h5>
											<Col md={6} className="mb-3">
												<AvField
													errorMessage="this field is required"
													className="mb-3"
													name={"iban"}
													label="IBAN Number (Optional)"
													bsSize="lg"
													validate={{
														pattern: { value: "/^[A-Za-z0-9]*$/" },
													}}
													value={formData.iban}
													onChange={(e) => handleFieldChange(e)}
													placeholder="IBAN Number"
													type="text"
												/>
											</Col>
											<Col md={6} className="mb-3">
												<AvField
													errorMessage="this field is required"
													name="swift"
													label="Swift Code (Optional)"
													bsSize="lg"
													validate={{
														pattern: { value: "/^[A-Za-z0-9]*$/" },
													}}
													value={formData.swift}
													onChange={(e) => handleFieldChange(e)}
													placeholder="Swift Code"
													type="text"
												/>
											</Col>
											<Col md={6} className="mb-3">
												<AvField
													errorMessage="This field is required"
													name={`bank_account`}
													label="Account Number (Optional)"
													placeholder="Account Number"
													bsSize="lg"
													value={formData.bank_account}
													onChange={(e) => handleFieldChange(e)}
													type="number"
												/>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Row>
						</Container>
						<ButtonCard />
					</AvForm>
				)}
				{formStep === 4 && (
					<PaymentPlan
						id={id}
						data={formData}
						addNewRelease={addNewRelease}
						updateFormData={setFormData}
						loading={loading}>
						<ButtonCard />
					</PaymentPlan>
				)}
				<CancelModal
					modal={modal}
					toggle={() => setModal(!modal)}
					btnOne="Cancel"
					btnTwo="Go Back"
					btnOneClick={() => setModal(false)}
					btnTwoOclick={() => props?.history?.goBack()}
				/>
				<SuccessModal
					modal={successModal}
					message={
						id
							? "Resale Updated successfully"
							: "New Resale has added successfully"
					}
					onClick={() => props.history.push(`${adminPrefix}/resale`)}
				/>
			</div>
		</>
	);
};

let validate = (str) => {
	let count = 0;
	for (let i = 0; i < str.length; i++) {
		if (
			(str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) ||
			(str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122)
		) {
			count += 1;
		}
	}

	return count >= 2 ? true : false;
};

let validateArabic = (str) => {
	let count = 0;
	for (let i = 0; i < str.length; i++) {
		if (str.charCodeAt(i) >= 1569 && str.charCodeAt(i) <= 1610) {
			count += 1;
		}
	}
	return count >= 2 ? true : false;
};

export default CreateResale;
